import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getServerTime } from '@shared/api/serverTime.api.ts';
import { extractError } from '@utils/slice';

export interface ServerTimeError {
    message?: string;
    [k: string]: any;
}

export interface ServerTimeState {
    time: string | null;
    error: ServerTimeError | null;
    isGetSystemDatePending: boolean;
}

const initialState: ServerTimeState = {
    time: null,
    error: null,
    isGetSystemDatePending: false,
};

export const fetchServerTime = createAsyncThunk<string, void, { rejectValue: ServerTimeError }>(
    'serverTime/fetchServerTime',
    (_, { rejectWithValue }) =>
        getServerTime()
            .then((res) => res)
            .catch((err) => rejectWithValue(err)),
);

const serverTimeSlice = createSlice({
    name: 'serverTime',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchServerTime.pending, (state) => {
            state.isGetSystemDatePending = true;
            state.error = null;
        });
        builder.addCase(fetchServerTime.fulfilled, (state, action) => {
            state.isGetSystemDatePending = false;
            state.time = action.payload;
        });
        builder.addCase(fetchServerTime.rejected, (state, action) => {
            state.isGetSystemDatePending = false;
            state.error = extractError(action);
        });
    },
});

export default serverTimeSlice.reducer;
